import type { SongRequest } from '../services/requests';

export const NOW_PLAYING_CLEARED_FLAGS: Partial<SongRequest> = {
  queuedInPlayer: false,
  queuedInSpotify: false,
  lockedNext: false,
  queueLockedAt: undefined,
  vipPriority: false,
};

export function buildNowPlayingUpdate(
  request: Pick<SongRequest, 'timestamps'> | undefined,
  startedAtIso: string,
  options: { manualPick?: boolean; playerTrack?: { title: string; artist: string } | null } = {},
): Partial<SongRequest> {
  return {
    status: 'nowPlaying',
    ...NOW_PLAYING_CLEARED_FLAGS,
    manualPickAt: options.manualPick ? startedAtIso : undefined,
    playerTrack: options.playerTrack ?? undefined,
    timestamps: {
      ...request?.timestamps,
      startedPlaying: startedAtIso,
    } as SongRequest['timestamps'],
  };
}

export function buildPlayedUpdate(
  request: Pick<SongRequest, 'timestamps'>,
  finishedAtIso: string,
): Partial<SongRequest> {
  return {
    status: 'played',
    timestamps: {
      ...request.timestamps,
      finishedPlaying: finishedAtIso,
    },
  };
}

// Only for the DJ's explicit "it didn't play" answer (ITER-173). Every other displacement goes to played.
export function buildBackToQueueUpdate(request: Pick<SongRequest, 'timestamps'>): Partial<SongRequest> {
  const timestamps = { ...request.timestamps };
  delete timestamps.startedPlaying;
  return {
    status: 'queued',
    ...NOW_PLAYING_CLEARED_FLAGS,
    manualPickAt: undefined,
    playerTrack: undefined,
    timestamps,
  };
}

export function buildPlayedToQueueUpdate(
  request: Pick<SongRequest, 'timestamps'>,
  manualOrder?: number,
): Partial<SongRequest> {
  const timestamps = { ...request.timestamps };
  delete timestamps.startedPlaying;
  delete timestamps.finishedPlaying;
  return {
    ...buildBackToQueueUpdate(request),
    manualOrder,
    timestamps,
  };
}

export function buildUndoBackToQueueUpdate(
  previous: Pick<SongRequest, 'timestamps' | 'manualOrder'>,
): Partial<SongRequest> {
  return {
    status: 'played',
    timestamps: previous.timestamps,
    manualOrder: previous.manualOrder,
  };
}
